import PropTypes from 'prop-types';

/** Forma de `tabPanelProps` en los layouts: lo que devuelve `getHeaderTabPanelProps`. */
export const tabPanelPropType = PropTypes.shape({
  'aria-labelledby': PropTypes.string,
  id: PropTypes.string,
  role: PropTypes.oneOf(['tabpanel']),
});
